import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { of, tap } from 'rxjs';
import { Router } from '@angular/router';
import { LoginResponse } from '../models/user.model';
import { FirebaseService } from './firebase.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  baseUrl = environment.apiUrl;
  http = inject(HttpClient);
  router = inject(Router);
  userService = inject(UserService);
  firebaseService = inject(FirebaseService);
  // afAuth = inject(AngularFireAuth);

  login(credintials: any) {
    return this.http.post<LoginResponse>(`${this.baseUrl}login`, credintials);
  }
  logout() {
    return this.http.post<LoginResponse>(`${this.baseUrl}logout`, {}).pipe(
      tap(() => this.logoutSuccess())
    );
  }
  logoutSuccess() {
    this.firebaseService.deleteToken();
    this.userService.clearStorageonLogout();
    this.router.navigate(['/login']);
    // return this.afAuth.signOut();
  }

  resetPassword(newPassword: { current_password: string, new_password: string }) {
    return this.http.put(`${this.baseUrl}reset-password`, newPassword);
  }

  getMyProfile() {
    return this.http.get<any>(`${this.baseUrl}profile`).pipe(
      tap(res => {
        res.user ? this.userService.setUser(res.user) : null
        res.permissions ? this.userService.setPermissions(res.permissions) : null
      })
    );
  }

}
